import { globalActions } from '../global-actions';

import { logStore } from './log-store';

const ACTIONS_HISTORY = 'actionsHistory';
const actionsHistory = [];

export function initActionsHistory() {
  if (!logStore()) {
    return;
  }
  const updateActionsHistory = (newState) => {
    actionsHistory.push(newState);
    sessionStorage.setItem(ACTIONS_HISTORY, JSON.stringify(actionsHistory));
  };

  globalActions.subscribe(updateActionsHistory);
}

export function addToStateHistory(name, store) {
  if (!logStore()) {
    return;
  }
  const stateHistory = [];
  sessionStorage.removeItem(name);
  store.subscribe((newState) => {
    stateHistory.push(newState);
    sessionStorage.setItem(name, JSON.stringify(stateHistory));
  });
}
